// assets
import { UserOutlined, KeyOutlined, SafetyOutlined, SettingOutlined, TeamOutlined } from '@ant-design/icons';

// icons
const icons = {
  UserOutlined,
  KeyOutlined,
  SafetyOutlined,
  SettingOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - USER MANAGEMENT ||============================== //

const userManagement = {
  id: 'group-user-management',
  title: 'User Management',
  type: 'collapse',
  icon: icons.TeamOutlined,
  children: [
    {
      id: 'manage-users',
      title: 'Manage Users',
      type: 'item',
      url: '/user-management/users',
      icon: icons.UserOutlined,
      description: 'Create, edit, and manage system users. Deactivation retains the record and audit history.'
    },
    {
      id: 'manage-roles',
      title: 'Manage Roles',
      type: 'item',
      url: '/user-management/roles',
      icon: icons.KeyOutlined,
      description: 'Define and manage system roles. Default roles: Admin and Support. Roles assigned to users cannot be deleted.'
    },
    {
      id: 'access-control',
      title: 'Access Control',
      type: 'item',
      url: '/user-management/access-control',
      icon: icons.SafetyOutlined,
      description: 'Assign menu permissions to roles. Hierarchy: Delete → Write → Read (checking a higher permission auto-checks lower ones). Export is tied to Read.'
    }
  ]
};

export default userManagement;
